<template>
	<div>
		<van-row>
			<van-col span="24">
				<van-image width="100%" :src=meetingAppImg />
				<template v-slot:loading>
					<van-loading type="spinner" size="20" />
				</template>
				</van-image>
			</van-col>
		</van-row>
		<br>
			<!-- 修改性别的弹窗 -->
		    <van-action-sheet v-model="show" description="请选择报名类型" @close="show = false" cancel-text="取消" @select="onSelect" v-if="show" :actions="actions">
		    </van-action-sheet>
		<div class="ydyContent">
			<van-row>
				<van-col span="24">
					<!-- <br>
          <van-button type="info"  round block size="normal" @click='sf' style="font-size: 16px;font-weight: bold;">参会代表报名（收费）</van-button>
          <br>
          <van-button type="info" round block size="normal" @click='mf' style="font-size: 16px;font-weight: bold;">观展代表报名（免费）</van-button> -->
					<br>
					<!-- <van-button type="info" round block size="normal" @click='person2'
						style="font-size: 16px;font-weight: bold;">参会报名</van-button> -->
					<van-button type="info" round block size="normal" @click='person'
						style="font-size: 16px;font-weight: bold;">个人报名</van-button>
					<br>
					<van-button type="info" round block size="normal" @click='team'
						style="font-size: 16px;font-weight: bold;">团体报名</van-button>
					
					<br>
					<div class="ydyBeizhu">
						<p style="font-size: 18px;"><b style="color: red;">会议说明：</b></p>
						<!-- <p>一、参会代表</p>
              <p>1、可出入区域：开幕式、主论坛、平行论坛会场、展区、餐区</p>
              <p>2、会议结束一个月内，截至2023年5月16日，未在系统内申请发票的用户，视为自动放弃开票，未申请学分的用户 视为放弃学分</p>
              <p>3、收费政策：</p>
              <p>3月31日前：1200元/人；4月1日-9日：1500元/人；4月9日后不接受汇款，请于线上或现场交费；</p>
              <p>已交注册费但未参会的人员，会务组可提供发票但不予退款。</p>
              <p>4、更换参会用户（收费用户） 请联系技术支持电话：15911046672</p>
              <p>二、普通代表</p>
              <p>可出入区域：平行论坛会场、展区、餐区</p> -->
						<div v-html="ydybz"></div>
						<!-- <p>一、参会代表</p>
              <p>1、可出入区域：会场、展区、餐区</p>
              <p>2、享有会议工作餐、资料包</p>
              <p>3、需前往报到处领取资料</p>
              <p>二、普通代表</p>
              <p>1、可出入区域：会场、展区</p>
              <p>2、无需前往报到处</p> -->
					</div>
					<!-- <div class="ydyBeizhu">
            <p>享受权益：<b style="color: red;">全程参会、大会资料、代表用餐、学分申请</b></p>
            <p>1、可出入区域：开幕式、主论坛、平行论坛会场、展区、餐区</p>
            <p>2、4月16日会议结束后，未在系统内申请发票的用户，视为自动放弃开票，未申请学分的用户 视为放弃学分</p>
            <p>3、收费政策：</p>
            <p>3月31日前：1200元/人；4月1日-9日：1600元/人；4月9日后不接受汇款，请于线上或现场交费；</p>
            <p>已交注册费但未参会的人员，会务组可提供发票但不予退款。</p>
            <p>4、更换参会用户（收费用户） 请联系技术支持电话：15911046672</p>
          </div>
          <br>
          <br>
            <van-button type="info" round block size="normal" style="font-size: 16px;font-weight: bold;">观展代表报名（免费）</van-button>
            <div class="ydyBeizhu">
              <p>不进入主论坛会场，不需要2022CHITEC会议资料的参会代表报名请点击：<span id="mf" style="cursor: pointer;color:#007bff;" @click='mf'>观展代表报名</span></p>
              <p>可出入区域：平行论坛会场、展区、餐区</p>
            </div> -->

				</van-col>
			</van-row>
		</div>
		
	</div>
</template>
<script>
	import moment from 'moment';
	export default {
		data() {
			return {
				show: false,
				actions: [
				  {
					name: '参会代表报名（收费）',
					className:'sf'
				  },
				  {
					name: '观展代表报名（免费）',
					className: 'mf',
				  }
				],
				meetingName: '',
				isBmf: this.$cookies.get('isBmf'),
				isEnterprisesParticipating: this.$cookies.get('isEnterprisesParticipating'),
				meetingAppImg: '',
				sfImg: require('@/assets/images/ydybtnsf.jpg'),
				mfImg: require('@/assets/images/ydybtnmf.jpg'),
				timestamp: Date.parse(new Date()),
				endTime: '',
				bmEndTime:'',
				ydybz: ''
			}
		},
		created() {
			this.clearData();
			this.meetingCode();
		},
		methods: {
			onSelect(event) {
				if(event.className == 'sf'){
					this.$cookies.set('cookie_entret_type', '2');
					this.$cookies.set('cookies_entret_isScore',this.getMeetingBycode.isScore);
					this.$router.push({
						path: '/index?meetingCode=' + this.$route.query.meetingCode,
					})
				}else if(event.className == 'mf'){
					this.$cookies.set('cookie_entret_type', '7');
					this.$router.push({
						path: '/index?meetingCode=' + this.$route.query.meetingCode,
					})
				}
				// layer.open({
				//   type: 1,
				//   title:false ,
				//   area: ['500px', 'auto'],
				//   closeBtn: 0,
				//   skin: 'hyxztc',
				//   content: '<h3>请选择报名类型</h3><div class="btns"><button id="sf" class="btn btn-primary">参会代表报名（收费）</button><span style="width: 66px;display: inline-block;"></span><button id="mf" class="btn btn-primary">观展代表报名（免费）</button></div>',
				//   success:function(layero, index){
				// 	  $('#mf').on('click', function() {
				// 		    this.$cookies.set('cookie_entret_type', '7');
				// 		    this.$router.push({
				// 		    	path: '/index?meetingCode=' + this.$route.query.meetingCode,
				// 		    })
				// 	  })
				// 	  $('#sf').on('click', function() {
				// 		  this.$cookies.set('cookie_entret_type', '2');
				// 		  this.$cookies.set('cookies_entret_isScore',this.getMeetingBycode.isScore);
				// 		  this.$router.push({
				// 		  	path: '/index?meetingCode=' + this.$route.query.meetingCode,
				// 		  })
				// 	  })
				//   }
				// });
			},
			clearData() {
				sessionStorage.removeItem('values');
				sessionStorage.removeItem('phone');
				this.$cookies.remove('cookies_meeting_order_key');
				this.$cookies.remove('cookies_meeting_order_payMoney');
				this.$cookies.remove('cookie_entret_type');
				this.$cookies.remove('cookise_order_outTradeNo');
				this.$cookies.remove('isBmf');
				this.$cookies.remove('isEnterprisesParticipating');
			},
			person(){
				var meetingCode = this.$route.query.meetingCode;
				if (meetingCode == '' || meetingCode == undefined || meetingCode == null || meetingCode == 'null') {
					this.$toast.fail('缺少会议code');
					return false;
				}
				if (this.bmEndTime < this.timestamp) {
					this.submitBtn = -1;
					this.$dialog.alert({
						message: '尊敬的各位嘉宾与同仁，感谢您对本次大会的热切关注。大会席位现已全部报满，报名通道已关闭。我们由衷感谢每一位关注者的支持！'
					});
					return false;
				}
				if(this.getMeetingBycode.isFreeUser == 1){ //是否有免费按钮
					this.show = true;
				}else{
					this.$cookies.set('cookie_entret_type', '2');
					this.$cookies.set('cookies_entret_isScore', this.getMeetingBycode.isScore);
					this.$router.push({
						path: '/index?meetingCode=' + this.$route.query.meetingCode,
					})
				}
			},
			person2(){
				var meetingCode = this.$route.query.meetingCode;
				if (meetingCode == '' || meetingCode == undefined || meetingCode == null || meetingCode == 'null') {
					this.$toast.fail('缺少会议code');
					return false;
				}
				if (this.bmEndTime < this.timestamp) {
					this.submitBtn = -1;
					this.$dialog.alert({
						message: '尊敬的各位嘉宾与同仁，感谢您对本次大会的热切关注。大会席位现已全部报满，报名通道已关闭。我们由衷感谢每一位关注者的支持！'
					});
					return false;
				}
				
				this.$cookies.set('cookie_entret_type', '7');
				this.$cookies.set('cookies_entret_isScore', this.getMeetingBycode.isScore);
				this.$router.push({
					path: '/index?meetingCode=' + this.$route.query.meetingCode,
				})
			},
			team(){
				this.$router.push({
					path: '/personal/teamreg?meetingId=' + this.$cookies.get('meetingId')
				})
			},
			mf() {

				var meetingCode = this.$route.query.meetingCode;
				if (meetingCode == '' || meetingCode == undefined || meetingCode == null || meetingCode == 'null') {
					this.$toast.fail('缺少会议code');
					return false;
				}
				if (this.bmEndTime < this.timestamp) {
					this.submitBtn = -1;
					this.$dialog.alert({
						message: '尊敬的各位嘉宾与同仁，感谢您对本次大会的热切关注。大会席位现已全部报满，报名通道已关闭。我们由衷感谢每一位关注者的支持！'
					});
					return false;
				}
				this.$cookies.set('cookie_entret_type', '7');
				this.$router.push({
					path: '/index?meetingCode=' + this.$route.query.meetingCode,
				})
			},
			sf() {
				var meetingCode = this.$route.query.meetingCode;
				if (meetingCode == '' || meetingCode == undefined || meetingCode == null || meetingCode == 'null') {
					this.$toast.fail('缺少会议code');
					return false;
				}
				if (this.bmEndTime < this.timestamp) {
					this.submitBtn = -1;
					this.$dialog.alert({
						message: '尊敬的各位嘉宾与同仁，感谢您对本次大会的热切关注。大会席位现已全部报满，报名通道已关闭。我们由衷感谢每一位关注者的支持！'
					});
					return false;
				}
				this.$cookies.set('cookie_entret_type', '2');
				this.$router.push({
					path: '/index?meetingCode=' + this.$route.query.meetingCode,
				})
			},
			//获取会议code
			meetingCode() {
				var meetingCode = this.$route.query.meetingCode;
				console.log(meetingCode)
				if (meetingCode == '' || meetingCode == undefined || meetingCode == null || meetingCode == 'null') {
					this.$toast.fail('缺少会议code');
					return false;
				}
				this.axios.get('/api/appweb/appMeeting/getMeetingBycode/' + meetingCode).then(res => {
					let data = res.data.data;
					if (res.data.status == 200) {
						var bmEndTime = moment(data.bmEndTime).format('YYYY-MM-DD')+' 23:59:59';
						
						this.ydybz = data.description;
						this.meetingName = data.meetingName;
						this.bmEndTime = moment(bmEndTime).valueOf();
						
						this.getMeetingBycode = data;
						if (data.id) {
							this.$cookies.set('meetingId', data.id)
						}
						if (data.meetingName) {
							this.$cookies.set('meetingName', data.meetingName)
						}
						var domain = window.location.host;
						//设置请求地址
						var http = process.env.API_ROOT;
						//if (domain.indexOf('127.0.0.1') > -1 || domain.indexOf('localhost') > -1 || domain.indexOf('meeting.ejectu.com') == 0) {
						//域名
						//http = "https://meeting.ejectu.com";
						//}
						if (data.attr2) {
							this.meetingAppImg = http + data.attr2
						}
						if (data.isBmf) {
							this.$cookies.set('isBmf', data.isBmf)
						}
						if (meetingCode == 'eusldlih') {
							this.$dialog.alert({
								message: '<h4 style="margin:.4em 0;/*text-indent:2em;*/text-align:left;">一、2022CHITEC大会免收注册费，订阅《中国卫生信息管理杂志》电子期刊的参会代表权益</h4><p style="margin:.4em 0;/*text-indent:2em;*/text-align:left;">（一）2022CHITEC会议资料（参会指南、论文汇编、案例汇编、最新1期《中国卫生信息管理杂志》；</p><p style="margin:.4em 0;/*text-indent:2em;*/text-align:left;">（二）会议期间（5-6日）工作午餐；</p><p style="margin:.4em 0;/*text-indent:2em;*/text-align:left;">（三）授予国家级I类继续医学教育学分6分；</p><p style="margin:.4em 0;/*text-indent:2em;*/text-align:left;">（四）出入会议区域（开幕式/主论坛会场、平行论坛会场、展区、餐区）不受限制。</p><p style="margin:.4em 0;/*text-indent:2em;*/text-align:left;color:red;">【温馨提示】尚未订阅杂志电子期刊的参会代表可在报名参会的同时进行杂志电子期刊的订阅。</p><h4 style="margin:.4em 0;/*text-indent:2em;*/text-align:left;">二、未订阅《中国卫生信息管理杂志》电子期刊的参会代表仅可出入平行论坛会场和展区，会议<ruby style="ruby-position:under;"></rt>不<rt>&bullet;</rt></ruby><ruby style="ruby-position:under;"></rt>提<rt>&bullet;</rt></ruby><ruby style="ruby-position:under;"></rt>供<rt>&bullet;</rt></ruby>工作午餐和2022CHITEC会议资料。</h4><h4 style="margin:.4em 0;/*text-indent:2em;*/text-align:left;">三、注意事项</h4><p style="margin:.4em 0;/*text-indent:2em;*/text-align:left;">（一）请订阅电子期刊的参会代表在会议结束10个工作日内在系统内申请发票（发票内容：订阅费），申请国家级I类继续医学教育学分也需在在会议结束10个工作日内在系统内办理。</p><p style="margin:.4em 0;/*text-indent:2em;*/text-align:left;">（二）联系人及联系方式</p><p style="margin:.4em 0;text-indent:3em;text-align:left;">电子期刊订阅咨询：张老师  010-88316507、13501114282</p><p style="margin:.4em 0;text-indent:3em;text-align:left;">技术支持工程师：吴老师 15911046672</p>',
								theme: 'round-button',
								title: '参会报名须知',
								className: 'loadContent'
							});
						}
						if (data.isEnterprisesParticipating) {
							this.$cookies.set('isEnterprisesParticipating', data.isEnterprisesParticipating)
						}
						if (data.isBmf == '0') {
							this.$cookies.set('cookie_entret_type', '7');
							this.$router.push({
								path: '/index?meetingCode=' + this.$route.query.meetingCode,
							})
						} else if (data.isBmf == '1' && data.isEnterprisesParticipating == '0') {
							this.$cookies.set('cookie_entret_type', '2');
							this.$router.push({
								path: '/index?meetingCode=' + this.$route.query.meetingCode,
							})
						}
						if (moment(bmEndTime).valueOf() < this.timestamp) {
							this.submitBtn = -1;
							this.disabled = true;
							this.$dialog.alert({
								message: '尊敬的各位嘉宾与同仁，感谢您对本次大会的热切关注。大会席位现已全部报满，报名通道已关闭。我们由衷感谢每一位关注者的支持！'
							});
							return false;
						}
					}
				});
			}
		}
	}
</script>
<style scoped="scoped">
	.ydyContent {
		padding: 0 20px;
	}

	.ydyTitle {
		background-color: #1989fa;
		color: #fff;
		font-weight: normal;
		display: inline-block;
		padding: 6px 18px;
		border-radius: 50px;
	}

	.ydyBeizhu {
		text-align: justify;
		line-height: 26px;
		color: #4d4d4d;
		padding: 10px;
		background: #f0f0f0;
		border-radius: 4px;
		font-size: 14px;
	}

	.ydyBeizhu p {
		margin: 2px 0;
	}

	.bmForm {
		padding: 20px 0;
	}

	.bmTitle {
		padding: 10px 20px 30px;
		line-height: 40px;
		background: url(~@/assets/images/titlebg.png) no-repeat bottom center;
		background-size: 100% 100%;
		color: #fff;
		text-align: center;
	}

	.bmTitle h2 {
		font-weight: normal;
	}

	.van-dialog__message {
		text-align: left !important;
		padding-top: 14px !important;
		text-align: justify !important;
	}
</style>


// WEBPACK FOOTER //
// src/components/Guide/index.vue